import React from 'react';
import { ShoppingCart, User, Heart, Search } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Template3 = () => {
    const navigate = useNavigate();

    return (
        <div className="w-full min-h-screen bg-white font-sans">
            {/* Mobile-optimized Header */}
                        {/* Header with Navigation */}
            <header className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
                <div className="container mx-auto px-4 lg:px-8">
                    <div className="flex justify-between items-center py-4 lg:py-5">
                        <h1 onClick={() => navigate('/template3')} className="text-2xl lg:text-3xl font-bold text-gray-900 cursor-pointer tracking-tight">
                            ELEGANCE
                        </h1>
                        <div className="flex items-center gap-4 lg:gap-6">
                            <Search className="w-5 h-5 text-gray-900 cursor-pointer hover:text-gray-600 transition-colors" />
                            <Heart className="w-5 h-5 text-gray-900 cursor-pointer hover:text-gray-600 transition-colors" />
                            <div className="relative cursor-pointer" onClick={() => navigate('/template3/cart')}>
                                <ShoppingCart className="w-5 h-5 text-gray-900 hover:text-gray-600 transition-colors" />
                                <span className="absolute -top-2 -right-2 bg-gray-900 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center font-medium">0</span>
                            </div>
                            <User className="w-5 h-5 text-gray-900 cursor-pointer hover:text-gray-600 transition-colors" onClick={() => navigate('/template3/profile')} />
                        </div>
                    </div>
                    <nav className="border-t border-gray-200">
                        <div className="flex justify-center items-center gap-8 lg:gap-12 py-4">
                            <button onClick={() => navigate('/template3')} className="text-sm lg:text-base font-medium text-gray-900 hover:text-gray-600 transition-colors uppercase tracking-wide">Home</button>
                            <button onClick={() => navigate('/template3/shop')} className="text-sm lg:text-base font-medium text-gray-900 hover:text-gray-600 transition-colors uppercase tracking-wide">Shop</button>
                            <button onClick={() => navigate('/template3/contact')} className="text-sm lg:text-base font-medium text-gray-900 hover:text-gray-600 transition-colors uppercase tracking-wide">Contact</button>
                            <button onClick={() => navigate('/template3/orders')} className="text-sm lg:text-base font-medium text-gray-900 hover:text-gray-600 transition-colors uppercase tracking-wide">Orders</button>
                        </div>
                    </nav>
                </div>
            </header>

            <main className="w-full">
                {/* Full-Width Hero Banner */}
                <section className="relative w-full min-h-[50vh] lg:min-h-[80vh] overflow-hidden">
                    <img
                        src="https://placehold.co/1920x1080/E0E0E0/333333?text=Hero+Banner"
                        alt="Banner"
                        className="absolute inset-0 w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-transparent" />
                    <div className="relative z-10 h-full min-h-[50vh] lg:min-h-[80vh] flex items-center px-3 sm:px-4 lg:px-12">
                        <div className="max-w-2xl">
                            <h1 className="text-3xl lg:text-6xl font-bold text-white mb-4 lg:mb-6 leading-tight">Unleash Your Style</h1>
                            <p className="text-base lg:text-xl text-white/90 mb-6 lg:mb-8 leading-relaxed">
                                Discover the latest trends in fashion that truly reflect your personality.
                            </p>
                            <button className="bg-white text-gray-900 px-6 lg:px-8 py-3 lg:py-4 rounded-lg font-semibold text-sm lg:text-base active:bg-gray-100 active:scale-95 lg:hover:bg-gray-100 lg:hover:scale-105 transition-all duration-300 shadow-xl">
                                Explore Collection
                            </button>
                        </div>
                    </div>
                </section>

                {/* Profile Section */}
                <section className="w-full bg-gray-50 py-8 lg:py-16 px-3 sm:px-4 lg:px-12">
                    <div className="flex flex-col lg:flex-row items-center gap-6 lg:gap-16">
                        <div className="relative flex-shrink-0">
                            <img
                                src="https://placehold.co/200x200/E0E0E0/333333?text=Profile"
                                className="w-32 h-32 lg:w-48 lg:h-48 object-cover rounded-full border-4 border-white shadow-xl ring-4 ring-gray-100/50 active:scale-95 lg:hover:scale-105 transition-all duration-300"
                                alt="Designer Profile"
                            />
                        </div>
                        <div className="flex-1 text-center lg:text-left">
                            <h1 className="text-3xl lg:text-5xl font-bold text-gray-900 mb-4 lg:mb-6 leading-tight">Designer's Name</h1>
                            <p className="text-base lg:text-xl text-gray-600 max-w-2xl mx-auto lg:mx-0 leading-relaxed">
                                A clean, timeless layout perfect for any store.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Category Carousel */}
                <section className="w-full py-8 lg:py-16 px-3 sm:px-4 lg:px-12">
                    <h2 className="text-2xl lg:text-4xl font-bold text-center mb-8 lg:mb-12 text-gray-900">
                        Shop by Category
                    </h2>
                    <div className="flex overflow-x-auto space-x-4 lg:space-x-6 pb-4 scrollbar-hide snap-x snap-mandatory -mx-3 px-3 sm:-mx-4 sm:px-4 lg:mx-0 lg:px-0">
                        {[
                            { name: "Indianwear", img: "https://placehold.co/400x500/E0E0E0/333333?text=Indianwear" },
                            { name: "Westernwear", img: "https://placehold.co/400x500/D0D0D0/333333?text=Westernwear" },
                            { name: "Blazers", img: "https://placehold.co/400x500/C0C0C0/333333?text=Blazers" },
                            { name: "Kurtis", img: "https://placehold.co/400x500/B0B0B0/333333?text=Kurtis" },
                            { name: "Accessories", img: "https://placehold.co/400x500/A0A0A0/333333?text=Accessories" }
                        ].map((cat) => (
                            <div key={cat.name} className="group relative overflow-hidden rounded-2xl shadow-lg active:scale-95 lg:hover:shadow-2xl lg:hover:scale-105 transition-all duration-500 w-60 lg:w-72 flex-shrink-0 snap-center">
                                <div className="aspect-[4/5] relative">
                                    <img src={cat.img} alt={cat.name} className="absolute inset-0 w-full h-full object-cover" />
                                    <div className="absolute inset-0 bg-black/60 group-hover:bg-black/40 transition-colors duration-300" />
                                    <div className="absolute bottom-0 w-full p-4 lg:p-6 bg-gradient-to-t from-black/60 via-transparent to-transparent text-white">
                                        <h3 className="text-xl lg:text-2xl font-bold">{cat.name}</h3>
                                        <div className="mt-1 text-sm flex items-center">
                                            Explore<svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Product Grid */}
                <section className="w-full bg-gray-50 py-12 lg:py-24 px-3 sm:px-4 lg:px-12">
                    <div className="text-center mb-8 lg:mb-12">
                        <h2 className="text-3xl lg:text-5xl font-bold text-gray-900 mb-3 lg:mb-4">All Products</h2>
                        <p className="text-base lg:text-xl text-gray-600">Discover our latest collection</p>
                    </div>

                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-2 lg:gap-6">
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(id => (
                            <div key={id} className="bg-white rounded-xl overflow-hidden shadow-sm border border-gray-200 active:scale-95 lg:hover:shadow-2xl lg:hover:-translate-y-1 lg:hover:border-gray-900 transition-all duration-200 group">
                                <div className="aspect-[3/4] overflow-hidden relative bg-gray-50">
                                    <img
                                        src={`https://placehold.co/400x500/F0F0F0/333333?text=Product+${id}`}
                                        alt={`Product ${id}`}
                                        className="object-cover object-center w-full h-full group-hover:scale-110 transition-transform duration-700"
                                    />
                                </div>
                                <div className="p-3 lg:p-4 space-y-2">
                                    <h3 className="text-sm lg:text-base font-semibold text-gray-900 line-clamp-1">Product Title {id}</h3>
                                    <p className="text-base lg:text-lg font-bold text-gray-900">${(69 + id * 10)}.00</p>
                                    <button className="w-full bg-gray-900 text-white py-2 px-4 rounded-lg font-semibold text-xs lg:text-sm active:bg-gray-800 lg:hover:bg-gray-800 transition-all duration-200">
                                        Add to Cart
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            </main>

                        {/* Footer */}
            <footer className="bg-gray-900 text-white mt-0">
                <div className="container mx-auto px-4 lg:px-8 py-12 lg:py-16">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-8 lg:gap-12">
                        <div>
                            <h3 className="text-2xl font-bold mb-4 tracking-tight">ELEGANCE</h3>
                            <p className="text-gray-400 text-sm leading-relaxed">Contemporary design excellence.</p>
                        </div>
                        <div>
                            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wide">Quick Links</h4>
                            <ul className="space-y-2 text-sm">
                                <li><span onClick={() => navigate('/template3')} className="text-gray-400 hover:text-white cursor-pointer transition-colors">Home</span></li>
                                <li><span onClick={() => navigate('/template3/shop')} className="text-gray-400 hover:text-white cursor-pointer transition-colors">Shop</span></li>
                                <li><span onClick={() => navigate('/template3/contact')} className="text-gray-400 hover:text-white cursor-pointer transition-colors">Contact</span></li>
                                <li><span onClick={() => navigate('/template3/orders')} className="text-gray-400 hover:text-white cursor-pointer transition-colors">Orders</span></li>
                            </ul>
                        </div>
                        <div>
                            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wide">Customer Service</h4>
                            <ul className="space-y-2 text-sm">
                                <li className="text-gray-400">Shipping & Returns</li>
                                <li className="text-gray-400">Privacy Policy</li>
                                <li className="text-gray-400">Terms & Conditions</li>
                                <li className="text-gray-400">FAQ</li>
                            </ul>
                        </div>
                        <div>
                            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wide">Connect</h4>
                            <p className="text-gray-400 text-sm">hello@elegance.com</p>
                        </div>
                    </div>
                    <div className="border-t border-gray-800 mt-12 pt-8">
                        <p className="text-center text-gray-500 text-sm">© 2025 ELEGANCE. All rights reserved.</p>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Template3;
